// LiveStreamTopLeaderboard.js
import { connect } from 'react-redux';
import addModal from '../action/addModal.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import fetchLiveStreamSessionLeaderboard from '../action/fetchLiveStreamSessionLeaderboard.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getLivestreamLeaderboard from '../selector/getLivestreamLeaderboard.js';
import LiveStreamTopLeaderboard from '../component/LiveStreamTopLeaderboard.jsx';
import { TOP_LEADERBOARD_USER_LEAST } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId, range, category }) => {
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const userIds = getLivestreamLeaderboard(
    state,
    streamId,
    sessionId,
    range,
    category,
    TOP_LEADERBOARD_USER_LEAST
  );
  return {
    streamId,
    sessionId,
    userIds,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setLiveStreamPanel: data => dispatch(setLiveStreamPanel(data)),
    fetchLiveStreamSessionLeaderboard: data =>
      dispatch(fetchLiveStreamSessionLeaderboard(data)),
    openModal: ({ id }) =>
      dispatch(
        addModal({ id, isHigherThanAll: true, transitionStatus: 'coming' })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamTopLeaderboard);
